<template>
  <div :class="[$style.wrapper]">
    <div :class="$style.flyout">
      <v-menu
        auto
        offset-y
        :content-class="$style.flyoutSearchPopup"
        :z-index="1000"
        :close-on-content-click="false"
      >
        <template #activator="{ on }">
          <div v-on="on">
            <v-btn color="primary" icon small :height="36" :width="36" :elevation="0">
              <v-icon large>mdi-magnify</v-icon>
            </v-btn>
          </div>
        </template>

        <v-list dense flat tile>
          <v-list-item-group>
            <v-list-item :ripple="false">
              <v-list-item-content>
                <v-list-item-title>
                  <NavigationProductSearchbar :class="$style.flyoutSearchbar" />
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>
    </div>

    <NavigationProductSearchbar :class="$style.searchbar" />
  </div>
</template>

<script>
import NavigationProductSearchbar from '@/js/components/Search/NavigationProductSearchbar.vue'

export default {
  name: 'FlyoutNavigationSearch',
  components: {
    NavigationProductSearchbar,
  },
}
</script>

<style lang="scss" module>
.searchbar {
  @media screen and (min-width: map-get($grid-breakpoints, 'lg')) {
    display: block;
  }
  display: block;
  display: none;
  width: 20vw;
}

.flyout {
  @media screen and (min-width: map-get($grid-breakpoints, 'md')) {
    display: block;
  }

  @media screen and (min-width: map-get($grid-breakpoints, 'lg')) {
    display: none;
  }
  display: none;
}

.flyoutSearchbar {
  min-width: 20rem;
}

.flyoutSearchPopup {
  // Setting centered popup via Vuetify classes didn't work
  // Center Search Popup under icon (36px width)
  transform: translateX(calc(-50% + 36px));
}
</style>
